export const STAFF_IDLE_MS = 60 * 60 * 1000;
const KEY = "mg_staff_activity";

export function isStaff(user) {
  return Boolean(user?.role) && !["patient", "guest"].includes(user.role);
}

export function beginStaffActivity(user, now = Date.now()) {
  if (isStaff(user)) sessionStorage.setItem(KEY, String(now));
  else sessionStorage.removeItem(KEY);
}

export function idleExpired(now = Date.now()) {
  const last = sessionStorage.getItem(KEY);
  return last !== null && (!Number.isFinite(Number(last)) || now - Number(last) >= STAFF_IDLE_MS);
}

export function recordStaffActivity(now = Date.now()) {
  if (idleExpired(now)) return false;
  sessionStorage.setItem(KEY, String(now));
  return true;
}

export function clearStaffActivity() {
  sessionStorage.removeItem(KEY);
}

export function hasStaffActivity() {
  return sessionStorage.getItem(KEY) !== null;
}
